const facilities = {
  cah: {
    dinamica: {
      title: "Dinámica de Fluidos Geofísicos Computacional",
      slug: "dinamica",
      // contact: {
      //   name: "Ivonne Katherine Montes Torres",
      //   email: ["dfgc@igp.gob.pe", "imontes@igp.gob.pe"],
      //   phone: "+51 13172300",
      //   annex: "135"
      // },
      sections: [
        {
          title: "Acerca de",
          slug: "",
          name: "About"
        },
        {
          title: "Inicio del Modelado Numérico en el IGP",
          slug: "modelado-numerico",
          name: "Modeling"
        },
        {
          title: "Investigaciones",
          slug: "investigaciones",
          name: "Publications"
        }
      ]
    },
    microfisica: {
      title: "Microfísica Atmosférica y Radiación",
      slug: "microfisica",
      contact: {
        name: "José Luis Flores Rojas",
        email: ["jflores@igp.gob.pe"],
        phone: "+51 13172300",
        annex: "135"
      },
      sections: [
        {
          title: "Acerca de",
          slug: "",
          name: "About"
        },
        {
          title: "Instrumentos",
          slug: "instrumentos",
          name: "Instruments"
        },
        {
          title: "Monitoreo LAMAR",
          slug: "monitoreo",
          name: "Monitoring"
        },
        {
          title: "Acceso a los datos",
          slug: "acceso-a-datos",
          name: "Resources"
        },
        {
          title: "Investigaciones",
          slug: "investigaciones",
          name: "Publications"
        }
      ]
    }
  }
};

function getFacilities(program) {
  return facilities[program] || facilities["cah"];
}
export { getFacilities };
